import { FC, useState } from "react";
import { DialogData, DialogHandle } from "../../types";
import { _, calcMaxChildren, parseNum } from "../../utils/helpers";
import { DEFAULT_DIALOG_HANDLE, SCREEN_BREAKPOINT_3 } from "../../utils/symbols";
import { Icon } from "../../parts/Icon";
import { useApp } from "../../context/useApp";
import { AddButton } from "../../parts/inputs/AddButton";

interface AddChildrenDialogProps {
    dialogData: DialogData
}

export const AddChildrenDialog: FC<AddChildrenDialogProps> = ({dialogData}) => {

    const {
        state: { dialogHandles, products, booking, screen }
    } = useApp()
    const [childrenToAdd, setChildrenToAdd] = useState(1)

    if (dialogData.dialog !== 'add-children') return null
    
    const dialogHandle:DialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE
    const childrensTicket = products.find(product => product.type === 'ticket' && product.category === 'children')
    const maxChildren = calcMaxChildren(booking.getAdults())


    const handleChildrenReplace = () => {

        let remaining = childrenToAdd
        let adultTickets = booking.getTickets({category: 'adult'})

        for (let ticket of adultTickets) {
            if (remaining === 0) break
            const locations = JSON.parse(JSON.stringify(ticket.layoutLocations))
            const adultTicket = products.find(product => product.id === ticket.productId)
            const childrensTicket = products.find(product => 
                product.type === 'ticket' &&
                product.category === 'children' &&
                product.zone === ticket.zone
            )

            if (!childrensTicket || !adultTicket) break

            for (let i = 0; i < ticket.qty; i++) {
                if (remaining === 0) break
                // if (alternate % 2 !== 0) continue
                const location = locations[i]

                booking.handleProduct('remove',adultTicket,location)
                booking.handleProduct('add',childrensTicket,location)
                remaining -= 1

                
            }
            
        }

        booking.render()
        dialogHandle.closeDialog()
    }

    const parsedPrice = parseNum('EUR', childrensTicket!.price)

    return (
        <section 
            className={`df fd-c aic jcc r3 section p-r py-10 px-10`}
            aria-label={`${_('3di_child_t')}, ${parsedPrice}. ${_('3di_uptoy__',' ')}`}
        >   
            <button 
                className="button b-0 p-2 p-a zi-6 close df aic jcc mt-0"
                onClick={() => dialogHandle.closeDialog()}
                aria-label={_('0ar_close__')}
            >
                <Icon icon="close" aria-hidden/>
            </button>
            <Icon icon="children" style={{scale: '2'}} className="my-10" aria-hidden/>
            <p id="dialog-label" className="text s21-600 center df fd-c mb-7" aria-hidden>
                {_('3di_child_t')}
            </p>
            <p id="dialog-description" className="text s19-400 center df fd-c mb-7" aria-hidden>
                {_('3di_indic__')}
            </p>
            <p className="text center df aic" aria-hidden>
                <span className="text s18-500 mr-5">{_('3zo_child__')}:</span>
                <span className="text s18-600 mr-3">{parsedPrice}</span>
                <span className="tooltip-container">
                    <Icon icon="info"/>
                    <span className="tooltip text center white nw s16-400 p-5" dangerouslySetInnerHTML={{__html: _('3di_uptoy__','<br />')}}>
                    </span>
                </span>
            </p>
            <AddButton
                alwaysDisplayCounter
                className="my-7"
                onAddButtonClick={setChildrenToAdd}
                qty={childrenToAdd}
                min={0}
                max={maxChildren}
            />
            {booking.pax < 2 && (<p className="text center s18-500 mb-7 red">{_('3zo_selec__')}</p>)}
            <button 
                disabled={booking.pax < 2}
                onClick={handleChildrenReplace}
                className="button b-0 px-10 py-7 df aic jcc black text s20-500 r3"
            >
                <span className="mr-5">{_('3di_repla__')}</span>
                {screen.width > SCREEN_BREAKPOINT_3 && (<Icon icon={'arrow'} className="rt-180"/>)}
            </button>
        </section>
    )
}